import React, {useState}  from "react";
import {useWorkingIndicator} from "./useBooleanToggler"
import {ethers} from "ethers";
import Web3Modal from "web3modal";
import axios from "axios";
import {nftCollabAddress, rpcEndpoint} from "../config";
import Token from "../artifacts/contracts/NFT1155Collab.sol/NFT1155Collab.json";
import {create as ipfsHttpClient} from "ipfs-http-client";
const client = ipfsHttpClient('https://ipfs.infura.io:5001/api/v0');
const useTokenCollab = () => {
    const {isWorking, startWork, finishWork} = useWorkingIndicator();
    const [collabsTokens, setTokens] = useState([]);
    const [isTransferring, setTransfer] = useState(false)
    const [isLoadingTokenCollab, setLoading] = useState(false)

    const uploadFileToIPFSCollab = async (file) => {
        console.log("file: " + file)
        try {
            const added = await client.add(
                file,
                {
                    progress: (prog) => console.log(`received: ${prog}`)
                }
            )
            const url = `https://ipfs.infura.io/ipfs/${added.path}`
            return url
        } catch (error) {
            console.log('Error uploading file: ', error)
            return null
        }
    }

    const transferTokenCollab = async (itemId, addresses) => {
        setTransfer(true)
        try {
            const web3Modal = new Web3Modal()
            const connection = await web3Modal.connect()
            const provider = new ethers.providers.Web3Provider(connection)
            const signer = provider.getSigner()
            const contract = new ethers.Contract(nftCollabAddress, Token.abi, signer)
            const arrayAd= addresses.replace(/ /g,'').split(",")
            const validAddres = [];
            for(let i=0; i<arrayAd.length; i++){
                let valid=ethers.utils.getAddress(arrayAd[i]);
                validAddres.push(valid);
            }
            const transaction = await contract.transferBatch(itemId, validAddres)
            await transaction.wait();
            await fetchTokensCollabs();
        } catch (err){
            console.log(err)
            if (err.data && err.data.message) {
                window.alert("Failed to Transfer Token: " + err.data.message)
            }
        }
        setTransfer(false)
    }

    const fetchTokensCollabs = async () => {
        try {
            const provider = new ethers.providers.JsonRpcProvider(rpcEndpoint)
            const tokenContract = new ethers.Contract(nftCollabAddress, Token.abi, provider)
            const data = await tokenContract.fetchAvailablesTokens()

            const items = await Promise.all(data.map(async i => {
                console.log("i: ", i);
                const tokenUri = await tokenContract.uri(i.tokenId)
                const meta = await axios.get(tokenUri);
                let item = {
                    price: meta.data.price,
                    itemId: i.tokenId.toNumber(),
                    quantity: i.amount.toNumber(),
                    file: meta.data.file,
                    name: meta.data.name,
                    image: meta.data.image,
                }
                return item
            }));
            setTokens(items)
        } catch(err){
            console.log(err)
            setTokens([])
            window.alert("Failed fetch tokens: " + err.data.message)
        }

    }




    const getAllTokenCollab = async () => {
        setLoading(true)
        await fetchTokensCollabs();
        finishWork();
        setLoading(false)
    }



    const mintTokenCollab = async ({quantity, ...rest}) => {
        console.log("mintTokenCollab: ", quantity, rest)
        startWork()
        const data = JSON.stringify({...rest, quantity});
        console.log("data", data)
        try{
            const added = await client.add(data);
            const url =  `https://ipfs.infura.io/ipfs/${added.path}`;
            await createSaleTokenCollab(url, quantity);

        }catch(error){
            console.log("error: ", error)
        }
    };

    const createSaleTokenCollab = async (url, quantity) => {
        try{
            const web3Modal = new Web3Modal()
            const connection = await web3Modal.connect()
            const provider = new ethers.providers.Web3Provider(connection)
            const signer = provider.getSigner()

            /* next, create the item */
            let contract = new ethers.Contract(nftCollabAddress, Token.abi, signer)
            let transaction = await contract.mint(quantity, url)
            let tx = await transaction.wait()
            let event = tx.events[0]
            let value = event.args[2]
            let tokenId = value.toNumber()
            window.alert("Created successfully")
            console.log("tokenId: ", tokenId);
            finishWork()
        } catch(err){
            console.log("   error: ", err)
            if (err.data && err.data.message) {
                window.alert("Failed to create NFT: " + err.data.message)
            }
            finishWork()
        }
    }

    return {
        uploadFileToIPFSCollab,
        isWorking, mintTokenCollab, fetchTokensCollabs, collabsTokens, isTransferring, transferTokenCollab, getAllTokenCollab, isLoadingTokenCollab
    };
};

export default useTokenCollab;
